export const GET_DICTIONARY_CONTACT_TYPES = Symbol('GET_DICTIONARY_CONTACT_TYPES');
export const GET_DICTIONARY_CONTACT_TYPES_REQUEST = Symbol('GET_DICTIONARY_CONTACT_TYPES_REQUEST');
export const GET_DICTIONARY_CONTACT_TYPES_SUCCESS = Symbol('GET_DICTIONARY_CONTACT_TYPES_SUCCESS');
export const GET_DICTIONARY_CONTACT_TYPES_ERROR = Symbol('GET_DICTIONARY_CONTACT_TYPES_ERROR');

